/*************************************************************************
* ADOBE CONFIDENTIAL
* ___________________
*
*  Copyright 2021 Adobe
*  All Rights Reserved.
*
* NOTICE:  All information contained herein is, and remains
* the property of Adobe and its suppliers, if any. The intellectual
* and technical concepts contained herein are proprietary to Adobe
* and its suppliers and are protected by all applicable intellectual
* property laws, including trade secret and copyright laws.
* Dissemination of this information or reproduction of this material
* is strictly forbidden unless prior written permission is obtained
* from Adobe.
**************************************************************************/
import { useStrict } from 'mobx';
import { auth } from './services/AuthAPI';
import { locale } from './services/LocaleAPI';
import AssetAPI from './services/AssetAPI';

// Force access to observables via actions
useStrict(true);

// Get providers from the global environment rather than from an import
// That way we don't have a compile-time dependency and we avoid bi-directional
// dependencies between dc-core and dc-mobx
const core = window.adobe_dc_sdk.appLauncher.coreFunction();
core.addProvider('asset', AssetAPI.getInstance);

export {
  auth,
  locale,
};
